import 'isomorphic-fetch';
import { notifyApiError } from '../common/actions';

function checkStatus(response) {
  if (response.status < 200 || response.status >= 300) {
    response.error = new Error(response.statusText);
  }
  return response;
}

function headersFor(body, cToken) {
  const headers = {
    Accept: 'application/json',
    'X-CSRF-Token': cToken
  };
  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}

function contentType(response) {
  let contentType;
  for (let entry of response.headers.entries()) {
    if (entry[0] === 'content-type') {
      contentType = entry[1];
    }
  }
  return contentType;
}

function fetchDownload(url, headers, method, body) {
  let filename = '';
  return fetch(url, {
    headers: headers,
    credentials: 'include',
    method,
    body
  })
    .then(response => {
      const header = response.headers.get('content-disposition');
      const parts = header.split(';');
      filename = parts[1].split('=')[1].replace(/^"|"$/g, '');
      return response.blob();
    })
    .then(blob => {
      const file = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = file;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(file);
    });
}

export default function api(
  dispatch,
  url,
  method,
  body,
  receiver,
  onError,
  ignoreErrors,
  callback,
  download,
  cToken
) {
  const headers = headersFor(body, cToken);
  if (download) {
    return fetchDownload(url, headers, method, body).then(
      dispatch(receiver({}))
    );
  } else {
    return fetch(url, {
      headers: headers,
      credentials: 'include',
      method,
      body
    })
      .then(checkStatus)
      .then(response => {
        // Use the response type to parse the body -- JSON
        const responseContentType = contentType(response) || '';
        if (responseContentType.toLowerCase().startsWith('application/json')) {
          return response.text().then(text => {
            if (!text?.length) {
              dispatch(receiver({}));
              if (callback) {
                callback();
              }
              return;
            }
            const json = JSON.parse(text);
            if (response.error) {
              json.sessionError =
                json.code === 'NO_SESSION' || json.code === 'INVALID_SESSION';
              const errObj = { error: response.error, apiError: json };
              dispatch(receiver(null, errObj));
              if (!ignoreErrors) {
                dispatch(notifyApiError(errObj, url));
                if (onError) {
                  this.onError();
                }
              }
            } else {
              dispatch(receiver(json));
              if (callback) {
                callback();
              }
            }
          });
          // Use the response type to parse the body -- TEXT  (errors only right now)
        } else if (responseContentType.toLowerCase().startsWith('text/plain')) {
          return response.text().then(text => {
            if (response.error) {
              dispatch(
                receiver(null, { error: response.error, apiErrorText: text })
              );
              if (onError) {
                this.onError();
              }
            }
          });
        } else {
          // What do we do here?  Server didn't send a response so we can't reliably parse the body
          console.warn(
            'Server sent an unsupported contentType',
            responseContentType
          );

          // Not going to try to parse an error body without contentType
          if (response.error) {
            dispatch(receiver(null, { error: response.error }));
            if (onError) {
              this.onError();
            }
            // But let's just assume json for now
          } else {
            return response.json().then(json => {
              dispatch(receiver(json));
            });
          }
        }
      })
      .catch(error => {
        console.error(`Unspecified error ${error}`);
      });
  }
}
